export default __webpack_public_path__ + "static/27_31-354808a8f381e1fe607526d396f3b6e4.png";